import React, { useState } from 'react';
import ReactDOM from "react-dom";
import JobOrderInstallationDataTable from "../../datatables/JobOrderInstallationDataTable";
import JobOrderInstallationCreateEditPage from "../JobOrderInstallationCreateEditPage";
import JobOrderInstallationShowPage from "../JobOrderInstallationShowPage";

export const INSTALLATION_PAGES = {
    INDEX:  'index',
    SHOW:   'show',
    CREATE: 'create',
    EDIT:   'edit',
}

const JobOrderInstallationPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        installationId  = null,
        page            = INSTALLATION_PAGES.INDEX,
        parentId        = "",
    } = props;


    const [currentPage, setCurrentPage]                     = useState(page);
    const [selectedInstallation, setSelectedInstallation]   = useState(!!installationId ? {id: installationId} : null);

    const handleChangePage = (page, installation) => {
        switch (page) {
            case INSTALLATION_PAGES.INDEX:
                window.history.pushState({}, '', route('job.order.installation.index', {job: jobId, order: orderId}).toString());
                break;
            case INSTALLATION_PAGES.SHOW:
                window.history.pushState({}, '', route('job.order.installation.show', {job: jobId, order: orderId, installation: installation.id}).toString());
                break;
            case INSTALLATION_PAGES.CREATE:
                window.history.pushState({}, '', route('job.order.installation.create', {job: jobId, order: orderId}).toString());
                break;
            case INSTALLATION_PAGES.EDIT:
                window.history.pushState({}, '', route('job.order.installation.edit', {job: jobId, order: orderId, installation: installation.id}).toString());
                break;
        }

        setCurrentPage(page);
        setSelectedInstallation(installation);
    }

    switch (currentPage) {
        case INSTALLATION_PAGES.SHOW:
            return (
                <JobOrderInstallationShowPage
                    jobId={jobId}
                    orderId={orderId}
                    installationId={!!selectedInstallation && !!selectedInstallation.id ? selectedInstallation.id : null}
                    onChangePage={(page, installation) => handleChangePage(page, installation)}
                    parentId={parentId}
                />
            );
        case INSTALLATION_PAGES.EDIT:
            return (
                <JobOrderInstallationCreateEditPage
                    jobId={jobId}
                    orderId={orderId}
                    installationId={!!selectedInstallation && !!selectedInstallation.id ? selectedInstallation.id : null}
                    onChangePage={(page, installation) => handleChangePage(page, installation)}
                    parentId={parentId}
                />
            );
        case INSTALLATION_PAGES.CREATE:
            return (
                <JobOrderInstallationCreateEditPage
                    jobId={jobId}
                    orderId={orderId}
                    installationId={null}
                    onChangePage={(page, installation) => handleChangePage(page, installation)}
                    parentId={parentId}
                />
            );
        case INSTALLATION_PAGES.INDEX:
        default:
            return (
                <JobOrderInstallationDataTable
                    jobId={jobId}
                    orderId={orderId}
                    onChangePage={(page, installation) => handleChangePage(page, installation)}
                    parentId={parentId}
                />
            );
    }
}

export default JobOrderInstallationPage;

const target = document.getElementById('job-order-installation-page');
if (target) {
    const {
        jobId           = null,
        orderId         = null,
        installationId  = null,
        page            = INSTALLATION_PAGES.INDEX,
        parentId        = 'job-order-installation-page'
    } = target.dataset;

    ReactDOM.render(
        <JobOrderInstallationPage
            jobId={jobId}
            orderId={orderId}
            installationId={installationId}
            page={page}
            parentId={parentId}
        />
        , target);
}

